import {
  defineField,
  defineType,
} from "sanity";

import {GROQMuxVideo, GROQVideoPlayerSchema} from "@/sanity/lib/definitions";

export type VideoPlayerSourceType = "mux" | "embedUrl" | "html";

export function resolveVideoSourceType(
  source?: Pick<IMuxVideoPlayer, "sourceType" | "embed">,
): VideoPlayerSourceType {
  if (
    source?.sourceType === "mux" ||
    source?.sourceType === "embedUrl" ||
    source?.sourceType === "html"
  ) {
    return source.sourceType;
  }

  return source?.embed ? "embedUrl" : "mux";
}

export const MuxVideoPlayer = defineType({
  title: 'Mux Video Player',
  name: 'muxVideoPlayer',
  type: 'object',
  fields: [
    defineField({
      name: 'sourceType',
      title: 'Video Source',
      type: 'string',
      initialValue: 'mux',
      options: {
        list: [
          { title: 'Mux Video', value: 'mux' },
          { title: 'Embed URL', value: 'embedUrl' },
          { title: 'HTML Code', value: 'html' },
        ],
        layout: 'radio',
      },
    }),
    defineField({
      name: 'embed',
      title: 'Embed (legacy)',
      type: 'boolean',
      initialValue: false,
      hidden: true,
    }),
    defineField({
      name: 'muxVideo',
      title: 'Mux Video',
      type: 'mux.video',
      hidden: ({ parent }) => resolveVideoSourceType(parent) !== 'mux',
    }),
    defineField({
      name: 'embedUrl',
      title: 'Embed URL',
      type: 'url',
      hidden: ({ parent }) => resolveVideoSourceType(parent) !== 'embedUrl',
    }),
    defineField({
      name: 'htmlCode',
      title: 'HTML Embed Code',
      description:
        'Paste the full snippet from your video platform (Vidalytics, Wistia, …), including both the <div> and the <script>.',
      type: 'text',
      rows: 10,
      hidden: ({ parent }) => resolveVideoSourceType(parent) !== 'html',
    }),
    defineField({
      name: 'thumbnail',
      title: 'Thumbnail',
      type: 'image',
    })
  ]
})

export interface IMuxVideoPlayer {
  sourceType?: VideoPlayerSourceType;
  embed: boolean;
  muxVideo: GROQMuxVideo;
  embedUrl: string;
  htmlCode?: string;
  thumbnail: any;
}

export const MuxVideoPlayerSchema = GROQVideoPlayerSchema;
